/* eslint-disable no-unused-vars */
/* global WebKitCSSMatrix, bsBreakpoints, sliderIndex, ModuloTS */

const SwiperKiller = (
	root,
	slidesPerView = { xl: 4, lg: 4, md: 3, sm: 2, xs: 1, xxs: 1 },

	options = {
		sliderIndex,
		paddingWrapper: 40,
		infinite: false,
		autoplay: false,
		pagination: false,
	}
) => {
	const element = document.querySelector(`.${root}`);
	const swiperKiller = element.querySelector('[data-sk]');
	const items = swiperKiller.querySelector('[data-sk-slides]');
	const wrapper = swiperKiller.querySelector('[data-sk-wrapper]');
	let prev;
	let next;
	const pause = swiperKiller.querySelector('[data-play]');
	const dot = swiperKiller.querySelector('[data-sk-index]') || null;
	const pagination = options.pagination
		? element.querySelector('[data-sk-pagination]')
		: null;
	const threshold = 20;
	let autoplay = !!options.autoplay;
	let autoPlayOn;
	let slides = items.querySelectorAll('[data-sk-slide]');
	let posX1 = 0;
	let posX2 = 0;
	let posInitial;
	let posFinal;
	let breakpoint;
	let gap;
	let index = options.sliderIndex;
	let slidePrev;
	let allowShift = true;

	const breakpoints = () => {
		bsBreakpoints.init();
		const bsBreakpoint = bsBreakpoints.getCurrentBreakpoint();
		if (bsBreakpoint === 'xLarge') {
			breakpoint = 'xl';
		} else if (bsBreakpoint === 'large') {
			breakpoint = 'lg';
		} else if (bsBreakpoint === 'medium') {
			breakpoint = 'md';
		} else if (bsBreakpoint === 'small') {
			breakpoint = 'sm';
		} else if (window.matchMedia('(min-width: 350px)').matches) {
			breakpoint = 'xs';
		} else {
			breakpoint = 'xxs';
		}
	};

	const SlidePerView = () => {
		if (breakpoint === 'xxs') {
			slidesPerView[breakpoint] =
				slidesPerView[breakpoint] !== undefined
					? slidesPerView[breakpoint]
					: 1;
		}
		return slidesPerView[breakpoint];
	};

	const slideSize = () => {
		const nbSlides = SlidePerView();
		const gaps = (nbSlides - 1) * gap;
		const size = wrapper.offsetWidth - gaps - options.paddingWrapper;
		const width = size / nbSlides;
		slides.forEach((slide) => {
			slide.style.minWidth = `${width + 'px'}`;
			slide.style.width = `${width + 'px'}`;
		});
	};

	const dragStart = (e) => {
		if (
			breakpoint === 'xxs' ||
			breakpoint === 'xs' ||
			breakpoint === 'sm' ||
			breakpoint === 'md'
		) {
			e = e || window.event;
			posInitial = 0;
			if (e.type === 'touchstart') {
				posX1 = e.touches[0].clientX;
			} else {
				posX1 = e.clientX;
				document.onmouseup = dragEnd;
				document.onmousemove = dragAction;
			}
		}
	};

	const getTranlateX = () => {
		const style = window.getComputedStyle(items);
		const matrix = new WebKitCSSMatrix(style.transform);
		return matrix.m41;
	};

	const dragAction = (e) => {
		if (
			breakpoint === 'xxs' ||
			breakpoint === 'xs' ||
			breakpoint === 'sm' ||
			breakpoint === 'md'
		) {
			e = e || window.event;

			if (e.type === 'touchmove') {
				posX2 = posX1 - e.touches[0].clientX;
				posX1 = e.touches[0].clientX;
			} else {
				posX2 = posX1 - e.clientX;
				posX1 = e.clientX;
			}

			items.style.transform = `translate(${
				getTranlateX() - posX2 + 'px'
			})`;
			if (index <= slides.length - 1 && index !== 0) {
				dotDot(index);
			}
		}
	};

	const dragEnd = (e) => {
		if (
			breakpoint === 'xxs' ||
			breakpoint === 'xs' ||
			breakpoint === 'sm' ||
			breakpoint === 'md'
		) {
			posFinal = getTranlateX();
			if (posFinal - posInitial < -threshold) {
				shiftSlide(1, 'drag');
			} else if (posFinal - posInitial > threshold) {
				shiftSlide(-1, 'drag');
			} else {
				items.style.transform = `translate(${posFinal + 'px'})`;
			}

			document.onmouseup = null;
			document.onmousemove = null;

			updatePagination();
		}
	};

	const shiftSlide = (dir, action, target = index, goShifting = true) => {
		const slideWidth = slides[0].offsetWidth;
		// eslint-disable-next-line no-unused-expressions
		goShifting ? swiperKiller.classList.add('shifting') : '';

		if (allowShift) {
			if (!action) {
				posInitial = items.offsetLeft;
			}

			if (dir === 1) {
				if (index !== slides.length - 1) {
					if (target === index) {
						index++;
					} else {
						index = target;
					}
				} else {
					index = 1;
				}
				items.style.transform = `translate(${
					-slideWidth - gap + 'px'
				})`;
			} else if (dir === -1) {
				if (index > 0) {
					if (target === index) {
						index--;
					} else {
						index = target;
					}
				} else {
					index = slides.length - 1;
				}
				items.style.transform = `translate(${slideWidth + gap + 'px'})`;
			}
		}
		// eslint-disable-next-line no-unused-expressions
		!goShifting ? changeOrder() : '';
		allowShift = true;
	};

	const dotDot = (index) => {
		if (dot) {
			dot.innerText = index;
		}
	};

	const calculateSlidesLeft = () => {
		const slideWidth = slides[0].offsetWidth;
		items.style.left =
			-(slideWidth + gap * 2 - options.paddingWrapper) + 'px';
		console.log(slideWidth + gap * 2 - options.paddingWrapper);
	};

	function checkIndex() {
		index = parseInt(index);

		if (index === 0) {
			index = slides.length - 1;
		}

		if (index === slides.length) {
			index = 1;
		}

		if (index === 1) {
			slidePrev = slides.length - 2;
		} else {
			slidePrev = index - 2;
		}

		allowShift = true;
	}

	const changeOrder = () => {
		checkIndex();
		const nbSlides = SlidePerView();
		swiperKiller.classList.remove('shifting');

		let order = 0;

		slides = items.querySelectorAll('[data-sk-slide]');

		for (let i = slidePrev; i < slides.length - 1; i++) {
			slides[i].style.order = order;
			order++;
		}

		for (let i = 0; i < slidePrev; i++) {
			slides[i].style.order = order;
			order++;
		}

		items.style.transform = `translate(0px)`;

		for (let i = 0; i < slides.length - 1; i++) {
			const getOrder = slides[i].style.order;
			if (getOrder > 0 && getOrder <= nbSlides) {
				displayFocus(slides[i]);
				slides[i].style.opacity = 1;
			} else {
				unDisplayFocus(slides[i]);
			}
		}

		cloneLast();
		// incrémentation du dotdot
		dotDot(index);
	};

	const displayNavButtons = () => {
		next.style.display = 'flex';
		prev.style.display = 'flex';
		if (!options.infinite) {
			if (index === slides.length - SlidePerView()) {
				next.style.display = 'none';
			}

			if (index === 1) {
				prev.style.display = 'none';
			}
		}
		if (slides.length - 1 <= SlidePerView()) {
			next.style.display = 'none';
			prev.style.display = 'none';
		}
	};

	const unDisplayFocus = (slide) => {
		const focusableElements =
			'button, [href], [tabindex]:not([tabindex="-1"])';
		const skFocusable = slide.querySelectorAll(focusableElements);
		skFocusable.forEach((el) => {
			el.tabIndex = -1;
		});

		slide.tabIndex = -1;
		slide.setAttribute('aria-hidden', true);
	};

	const displayFocus = (slide) => {
		const focusableElements =
			'button, [href], [tabindex]:not([tabindex="-1"])';
		const slideFocusable =
			slide.querySelectorAll(focusableElements) || null;
		if (slideFocusable.length > 0) {
			slideFocusable.forEach((el) => {
				el.tabIndex = 0;
			});
		}
		slide.setAttribute('aria-hidden', false);
		slide.style.opacity = 1;
	};

	const firstClone = () => {
		if (!wrapper.querySelector('.last')) {
			slides[slides.length - 1].classList.add('first');
			const clone = slides[slides.length - 1].cloneNode(true);
			clone.style.order = slides.length;
			clone.classList.add('last');
			items.appendChild(clone);
			slides = items.querySelectorAll('[data-sk-slide]');
		}
	};

	const cloneLast = () => {
		slides.forEach((slide) => {
			slide.classList.remove('first');
		});
		slides[slidePrev].classList.add('first');
		const clone = slides[slidePrev].cloneNode(true);

		items.replaceChild(clone, element.querySelector('.last'));
		clone.classList.add('last');
		element.querySelector('.last').style.order = slides.length - 1;
	};

	const calculateGap = () => {
		const left = parseInt(
			window.getComputedStyle(slides[0]).marginLeft,
			10
		);
		const right = parseInt(
			window.getComputedStyle(slides[0]).marginRight,
			10
		);

		gap = right + left;
	};

	/**
	 * @description activation de l'autoplay
	 */
	const playSlider = (duration) => {
		pause.setAttribute('data-play', 'pause');
		pause.classList.add('autoplay-active');
		autoPlayOn = setInterval(() => {
			shiftSlide(1);
			updatePagination();
		}, duration);
		autoplay = true;
	};

	/**
	 * @description stop de l'autoplay
	 */
	const pauseSlider = (autoplayOn) => {
		pause.setAttribute('data-play', 'play');
		clearInterval(autoplayOn);
		autoplay = false;
	};

	/**
	 * @description création  de la pagination dotdot
	 */
	const createPagination = () => {
		let paginationDot = '';
		for (let i = 0; i < slides.length - 1; i++) {
			paginationDot += `<li class="sk-dot " tabindex="0" data-sk-dot="${
				i + 1
			}"></li>`;
		}

		pagination.insertAdjacentHTML('beforeend', paginationDot);
		managePagination();
		updatePagination();
	};

	/**
	 * @description création des boutons de navigation
	 */

	const createNavBtns = () => {
		const navPrev = swiperKiller.querySelector('[data-prev]') || null;
		const navNext = swiperKiller.querySelector('[data-next]') || null;

		if (!navNext && !navPrev) {
			const btnNext = `<button class="control next" type="button" data-next>
								<span class="sr-only">${ModuloTS['Next slide']}</span>
							</button>`;
			const btnPrev = `<button class="control prev" type="button" data-prev>
								<span class="sr-only">${ModuloTS['Previous slide']}</span>
							</button>`;
			wrapper.insertAdjacentHTML('beforebegin', btnPrev);
			wrapper.insertAdjacentHTML('beforebegin', btnNext);
			prev = swiperKiller.querySelector('[data-prev]');
			next = swiperKiller.querySelector('[data-next]');
		} else {
			prev = navPrev;
			next = navNext;
		}
	};

	/**
	 * @description update la pagination
	 */
	const updatePagination = () => {
		if (options.pagination) {
			const dotdots = document.querySelectorAll('[data-sk-dot]');
			dotdots.forEach((dot) => {
				const getInt = parseInt(dot.getAttribute('data-sk-dot'));
				getInt === index
					? dot.classList.add('sk-dot--active')
					: dot.classList.remove('sk-dot--active');
			});
		}
	};

	/**
	 * @description stop autoplay à la nav clavier
	 */
	const keyboardStopAutoplay = () => {
		document.addEventListener('keyup', (e) => {
			if (e.key === 'Tab' && document.activeElement === prev) {
				pauseSlider(autoPlayOn);
			}
		});
	};

	/**
	 * @description gestion au clic  de la pagination dotdot
	 */
	const managePagination = () => {
		const dotdots = document.querySelectorAll('[data-sk-dot]');
		dotdots.forEach((dot) => {
			let listener = '';
			breakpoint === 'xxs' || breakpoint === 'xs'
				? (listener = 'touchstart')
				: (listener = 'click');
			dot.addEventListener(listener, () => {
				if (autoplay) {
					pauseSlider(autoPlayOn);
				}
				const active = document
					.querySelector('.sk-dot--active')
					.getAttribute('data-sk-dot');
				const current = dot.getAttribute('data-sk-dot');
				if (active !== current) {
					// Si on clique sur un autre dot que l'active
					dotdots.forEach((dot) =>
						dot.classList.remove('sk-dot--active')
					);
					dot.classList.add('sk-dot--active');
					const slidePrev = slides[current - 1];
					const slideCurrent = slides[current];
					slideCurrent.style.order = '1';
					if (active < current) {
						shiftSlide(1, '', current, false);
					} else {
						shiftSlide(-1, '', current, false);
					}
				}
			});
		});
	};

	const touch = () => {
		// Mouse events
		items.onmousedown = dragStart;

		// Touch events
		items.addEventListener('touchstart', dragStart);
		items.addEventListener('touchend', dragEnd);
		items.addEventListener('touchmove', dragAction);
	};

	const actions = () => {
		let listener = '';
		breakpoint === 'xs' ? (listener = 'touchstart') : (listener = 'click');
		displayNavButtons();
		touch();

		// Click events

		prev.addEventListener(listener, () => {
			shiftSlide(-1);
			updatePagination();
			transitionEnd();
		});

		next.addEventListener(listener, () => {
			shiftSlide(1);
			updatePagination();
			transitionEnd();
		});

		const transitionEnd = () => {
			items.addEventListener('transitionend', function (e) {
				if (e.propertyName !== 'order') {
					changeOrder();
					displayNavButtons();
				}
			});
		};
	};

	const firstLoad = () => {
		calculateGap();
		breakpoints();
		firstClone();
		slideSize();
		dotDot(options);
		calculateSlidesLeft();
	};

	const init = () => {
		createNavBtns();
		breakpoints();
		displayNavButtons();

		if (slides.length > 1) {
			window.addEventListener('resize', () => {
				firstLoad();
				displayNavButtons();
				changeOrder();
				touch();
			});

			firstLoad();
			changeOrder();
			if (autoplay) {
				playSlider(5000);
				keyboardStopAutoplay();
				const btns = swiperKiller.querySelectorAll('.btn');
				btns.forEach((btn) => {
					let listener = '';
					breakpoint === 'xxs' || breakpoint === 'xs'
						? (listener = 'touchstart')
						: (listener = 'click');
					btn.addEventListener(listener, () => {
						if (btn.classList.contains('pause')) {
							autoplay
								? pauseSlider(autoPlayOn)
								: playSlider(3000);
						} else {
							pauseSlider(autoPlayOn);
						}
					});
				});
			}
			if (options.pagination) {
				createPagination();
			}

			actions();
			items.addEventListener('transitionend', function (e) {
				if (e.propertyName !== 'order') {
					changeOrder();
					displayNavButtons();
				}
			});
			unDisplayFocus(items);
		}
	};

	init();
};
